<template>
  <div v-loading="isLoading" class="mt-14.5 flex justify-center w-full">
    <div v-if="hasDevices" class="flex flex-col items-center gap-8 w-full">
      <DeviceCarousel class="max-w-388 overflow-x-hidden" />
    </div>

    <!-- 缺省页 -->
    <DeviceEmptyState v-else />
  </div>
</template>

<script lang="ts" setup>
  import { computed } from 'vue'
  import { storeToRefs } from 'pinia'
  import { useDeviceStore } from '@/stores/device'
  import DeviceCarousel from './components/deviceCarousel/index.vue'
  import DeviceEmptyState from './components/emptyState/index.vue'

  const deviceStore = useDeviceStore()
  const { isLoading, deviceList } = storeToRefs(deviceStore)

  const hasDevices = computed(() => deviceList.value.length > 0)
</script>

<style lang="scss" scoped></style>
